// src/components/shared/SelectEditCell.js
// Reusable MRT inline-edit cell that renders a MUI Select dropdown.
// Usage in a column definition:
//   Edit: ({ cell }) => <SelectEditCell cell={cell} field="STATE" label="Status" options={["Active", "Disable"]} />

import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const SelectEditCell = ({ cell, field, label, options }) => {
  const [value, setValue] = React.useState(cell.row.original[field]);

  const handleChange = (event) => {
    cell.row._valuesCache[field] = event.target.value;
    setValue(event.target.value);
  };

  return (
    <Box>
      <InputLabel size="small" shrink sx={{ bottom: -5 }}>
        {label}
      </InputLabel>
      <Select
        variant="standard"
        value={value}
        defaultValue={cell.row.original[field]}
        onChange={handleChange}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default SelectEditCell;
